import { PropsWithChildren } from 'react';

function FrontPageLayout({ children }: PropsWithChildren) {
  return (
    <div className="text-foreground bg-background relative flex flex-col min-h-screen">
      <main className="grow flex flex-col">
        {children}
      </main>
    </div>
  );
}

export default FrontPageLayout;
